export const UPDATE_ACCOUNT_GMB = 'UPDATE_ACCOUNT_GMB';
export const FETCH_ACCOUNT_START = 'FETCH_ACCOUNT_START';
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS';
export const FETCH_ACCOUNT_FAILURE = 'FETCH_ACCOUNT_FAILURE';

export const ACCOUNT_CLEAR_STORE = 'ACCOUNT_CLEAR_STORE';
